var _defs, _use;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10.742 0a.5.5 0 0 1 .5.5v2.027c.979.311 1.863.82 2.601 1.477l1.822-1.008a.5.5 0 0 1 .67.18l1.574 2.613a.5.5 0 0 1-.186.696l-1.785.988a6.566 6.566 0 0 1 0 3.055l1.785.987a.5.5 0 0 1 .186.696l-1.574 2.613a.5.5 0 0 1-.67.18l-1.822-1.008a7.183 7.183 0 0 1-2.6 1.477V17.5a.5.5 0 0 1-.5.5H7.705a.5.5 0 0 1-.5-.5l-.001-1.9a7.198 7.198 0 0 1-3.048-1.604l-1.822 1.008a.5.5 0 0 1-.67-.18L.09 12.211a.5.5 0 0 1 .186-.696l1.785-.988a6.566 6.566 0 0 1 0-3.054L.277 6.485a.5.5 0 0 1-.186-.696l1.574-2.613a.5.5 0 0 1 .67-.18l1.822 1.008a7.198 7.198 0 0 1 3.048-1.603L7.206.5a.5.5 0 0 1 .5-.5h3.036zM9 5a4 4 0 1 0 0 8 4 4 0 0 0 0-8z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    transform: "translate(3 3)",
    xlinkHref: "#a"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e685445e289617c24820ea5d63964f4a.svg";
export { ForwardRef as ReactComponent };